module.exports = __webpack_public_path__ + "img/image6.f2a9bb60.png";